export default __webpack_public_path__ + "static/media/back.085fce58.png";